import {HTTP} from '../../services/api-service.js';
import commonObj from '../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
// var tableName = 'BusinessEntity';

const newOrderStore = {
    namespaced: true,
    state:{
        filter_menu_expand: true,
        totalItem:0,
    },
    mutations:{
        toggleFilterMenu(state){
            state.filter_menu_expand = !state.filter_menu_expand;
        }
    },
    actions:{
        getBrandFilterList({commit, state}) {
            return new Promise((resolve, reject) => {
                var hardcode_filter_list = {
                    success: true,
                    data: [
                        {text: "Latest Release", id: "latest_release", value: "LR"},
                        {text: "Brand", id: "brand", value: "BRAND"},
                        {text: "Category 1", id: "category_1", value: "CATE1CODE"},
                        {text: "Category 2", id: "category_2", value: "CATE2CODE"},
                        {text: "Series", id: "series", value: "SERIES"},
                        {text: "Character", id: "character", value: "CHARCODE"},
                        {text: "Catalog", id: "catalog", value: "CATALOG"}
                    ]
                }

                resolve(hardcode_filter_list);
            })
        },
        getBrandList({commit, state}, filter) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/item/GetItemDimList').then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })
            })
        },
        getProductList({commit, state}, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/item/GetItemList', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })

            })
        },
        getProductDetail({commit, state}, param){
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/item/GetItemProfile', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })

            })
        }
    }
};
export default newOrderStore;